import {Checkbox, Column, Row, Switch, TableRowSelectionHook} from '@vidazoo/ui-kit';
import {ReactComponent as EditIcon} from '../assets/edit.svg';
import {ReactComponent as DeleteIcon} from '../assets/delete.svg';
import React from 'react';
import {observer} from 'mobx-react';
import {ChartsListModel} from '../model/ChartsListModel.mdl';
import {Link, useNavigate} from 'react-router-dom';
import UrlsService from '../../../../common/router/services/urlsService.mdl';
import MarkeredText from '../../../../common/components/markered-text/MarkeredText';
import dayjs from 'dayjs';
import {useChartsListContext} from '../context/ChartsListContext';
import theme from '../view/theme.module.scss';

export interface IChartsTableRowProps {
    columnsManager: ChartsListModel;
    tableRowSelectionHook: TableRowSelectionHook;
    itemIndex: number;
    viewportIndex: number;
    style: React.CSSProperties;
}

export default observer(function ChartsTableRow({itemIndex, style, columnsManager: model}: IChartsTableRowProps) {
    const {tableRowSelectionHook: {isItemSelected, toggleItem}} = useChartsListContext();
    const navigate = useNavigate();
    const item = model.maskItems.at(itemIndex);
    if (!item) return null;
    const background = itemIndex % 2 ? 'var(--charts-row-odd-background)' : 'var(--charts-row-background)';
    const rowStyle = {...style, '--table-viewport-background-color': background,
        '--table-data-column-background-color': background, '--table-column-sticky-background-color': background} as React.CSSProperties;
    const pending = model.pendingIds.includes(item._id);
    const date = value => value && dayjs(value).isValid() ? dayjs(value).format('MMM DD, YYYY') : '';
    return <Row style={rowStyle} index={itemIndex} data-chart-id={item._id}>
        <Column colKey="checkbox"><Checkbox aria-label={`Select ${item.name}`} checked={isItemSelected(item._id)}
            disabled={pending} onChange={() => toggleItem(item._id)}/></Column>
        <Column colKey="name"><Link to={UrlsService.editChart(item._id)}>
            <MarkeredText marker={model.getColumnSearchQuery('name')}>{item.name}</MarkeredText>
        </Link></Column>
        <Column colKey="type">{item.type}</Column>
        <Column colKey="created">{date(item.created)}</Column>
        <Column colKey="updated">{date(item.updated)}</Column>
        <Column colKey="isActive"><Switch small aria-label={`Active ${item.name}`} checked={item.isActive}
            disabled={pending} onChange={() => model.toggleActive(item)}/></Column>
        <Column colKey="actions"><div className={theme.rowActions}>
            <button className={theme.iconAction} type="button" aria-label={`Edit ${item.name}`}
                onClick={() => navigate(UrlsService.editChart(item._id))}><EditIcon aria-hidden="true" focusable="false"/></button>
            <button className={theme.iconAction} type="button" disabled={pending}
                aria-label={`Delete ${item.name}`} onClick={() => model.confirmDelete(item)}><DeleteIcon aria-hidden="true" focusable="false"/></button>
        </div></Column>
    </Row>;
});
